import React, { useState } from 'react';
import { Button, Drawer, Grid, Typography } from 'antd';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import './Navbar.css';
import logo from '../images/brandsenpaiwhite.png'; // keep your path

const { useBreakpoint } = Grid;
const { Title } = Typography;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const screens = useBreakpoint();

  const close = () => setOpen(false);
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    close();
  };

  const links = [
    { label: 'Services', id: 'services' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header className="bs-navbar">
      <div className="bs-nav-inner">
        
        <div className="bs-nav-left" onClick={() => go('top')} role="button" tabIndex={0}>
          <img src={logo} alt="BrandSenpai logo" className="bs-logo" />
          <Title level={3} className="bs-brand">BrandSenpai</Title>
        </div>

        {screens.md && (
          <nav className="bs-links">
            {links.map(x => (
              <button key={x.id} className="bs-link" onClick={() => go(x.id)}>
                {x.label}
              </button>
            ))}
          </nav>
        )}

        {!screens.md && (
          <Button
            type="text"
            className="bs-menu-btn"
            icon={<MenuOutlined />}
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          />
        )}

        <Drawer
          placement="right"
          width={280}
          open={open}
          onClose={close}
          closeIcon={<CloseOutlined />}
          className="bs-drawer"
          title={null}
        >
          <nav className="bs-drawer-links">
            {links.map(x => (
              <button key={x.id} className="bs-drawer-link" onClick={() => go(x.id)}>
                {x.label}
              </button>
            ))}
          </nav>
        </Drawer>
      </div>
    </header>
  );
};

export default Navbar;
